import { useSelectTheme } from "../../../store/state/theme";
import { defaultSvgProps, SvgProps } from "../type/props";

export const RefreshIcon = (props?: SvgProps) => {
  const { color } = useSelectTheme();
  const { width, height, fill, style } = defaultSvgProps(props, {
    width: 16,
    height: 16,
    fill: color.primary,
    style: {
      flexShrink: 0,
    },
  });

  return (
    <svg
      width={width}
      height={height}
      style={style}
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M6.41574 2.86205L3.77081 1.6219L4.53128 0L9.92987 2.53128L7.3986 7.92988L5.7767 7.1694L7.00125 4.55774C5.149 5.07962 3.79133 6.78168 3.79133 8.80084C3.79133 11.2352 5.76478 13.2087 8.19916 13.2087C10.6335 13.2087 12.607 11.2352 12.607 8.80084H14.3983C14.3983 12.2245 11.6229 15 8.19916 15C4.77546 15 2 12.2245 2 8.80084C2 5.99708 3.86134 3.62805 6.41574 2.86205Z"
        fill={fill}
      />
    </svg>
  );
};
